import api from './api'

export default {
  async getTaskList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskList(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskCount({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskCount(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskConfig({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskConfig(params)
      commit('updateTaskConfig', res.data)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskTypeList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskTypeList(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskDetail({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskDetail(params)
      commit('updateTaskDetail', res.data)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskTypeDetail({ commit, state }, params) {
    console.log('params', params)
    let res = {}
    try {
      res = await api.getTaskTypeDetail(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskUpdate({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskUpdate(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskRemind({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskRemind(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskRejectRemind({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskRejectRemind(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskEdit({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskEdit(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskReject({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskReject(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getShopIndicator({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getShopIndicator(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskCreate({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskCreate(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getTaskRemarkList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getTaskRemarkList(params)
      commit('updateTaskRemarkList', res.data?.list)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
}
